import LibraryBooksOutlined from '@mui/icons-material/LibraryBooksOutlined';
import { t } from 'i18next';

export default function getDownloadJobCardPdfsContent() {
  return {
    icon: <LibraryBooksOutlined />,
    label: t('dispatch.order.download_job_card_pdfs'),
  };
}
